import { Component, OnChanges, Input, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { ApiService, } from "src/app/api.service";
import { ChartingService } from "src/app/charting.service";
import { DvsChartComponent } from "src/app/shared/dvs-chart/dvs-chart.component";
import { AssemblyConfig, APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-shaft-detail",
	templateUrl: "./shaft-detail.component.html",
	styleUrls: ["./shaft-detail.component.scss"],
	imports: [DvsChartComponent, FormsModule]
})
export class ShaftDetailComponent implements OnChanges {
	private api = inject(ApiService);
	private charting = inject(ChartingService);

	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	component: AssemblyConfig.Shaft;
	@Input()
	raw: APIResults.RawPairsResult;

	public tsoptions?: Highcharts.Options;
	public spectrumoptions?: Highcharts.Options;
	public errormessage: string;
	public useorder = false;

	ngOnChanges() {
		this.UpdateChart();
	}

	async UpdateChart() {
		if (this.asset && this.component && this.raw) {
			this.tsoptions = undefined;
			this.spectrumoptions = undefined;
			this.errormessage = undefined;
			try {
				const result = await this.api.GetShaftVibe(this.asset.asset_id, this.component.id, this.raw.tachrawid, this.raw.viberawid, this.useorder);
				this.tsoptions = this.charting.RevolutionDefaults("Time Sync Avg", result.tsastats, result.rpm, result.tsa, "Gs");
				this.spectrumoptions = this.charting.SpectrumDefaults("Spectrum", "Gs", [
					{ type: "line", name: "Raw Spectrum", data: result.spectrum },
					{ type: "line", name: "TSA Spectrum", zIndex: 1, data: result.fft },
				], this.useorder);
			} catch (err) {
				this.errormessage = "Unable to load shaft details";
				console.error("Couldn't load shaft vibe");
				console.log(err);
			}
		}
	}

}
